import { useEffect, useState } from "react";

export default function useMediaQuery(minMax: "min" | "max", media: number): boolean {
  const mediaQuery = window.matchMedia(`(${minMax}-width:${media}px)`);
  const [isValid, setIsValid] = useState<boolean>(mediaQuery.matches);
  useEffect(() => {
    const cb = (e:MediaQueryListEvent) => {
      return setIsValid(e.matches);
    };
    mediaQuery.addEventListener("change", cb);
    return () => mediaQuery.removeEventListener("change", cb);
  }, [mediaQuery]);
  return isValid;
}
